/**
 * Comparison Table section
 * --------------------------------------------------------------------------
 * Mobile is a 2-up "compare" view: two columns, each with a <select> that
 * swaps in any model. Every model's content is already in the DOM per
 * column (comparison-table-panel snippet, rendered once per slot per
 * block) — this script only toggles which panel is visible via the
 * `hidden` attribute, and keeps the two selects from both landing on the
 * same model at once by disabling that option on the sibling select.
 *
 * Desktop is unaffected: the compare view is hidden there via CSS, and
 * this script is a no-op if a section has no compare columns.
 *
 * Multiple instances of the section can exist on one page, so everything is
 * scoped per-instance and re-initialized on Shopify's section load event.
 */

(function () {
  'use strict';

  function initComparisonTable(root) {
    if (!root || root.dataset.comparisonTableInit === 'true') return;

    var cols = Array.prototype.slice.call(
      root.querySelectorAll('.comparison-table__compare-col')
    );
    if (cols.length < 2) return; // single-model fallback has no select to wire up

    root.dataset.comparisonTableInit = 'true';

    var slots = cols.map(function (col) {
      return {
        select: col.querySelector('.comparison-table__compare-select'),
        panels: Array.prototype.slice.call(
          col.querySelectorAll('.comparison-table__compare-panel')
        ),
      };
    });

    function showPanel(slot, value) {
      slot.panels.forEach(function (panel) {
        panel.hidden = panel.dataset.index !== value;
      });
    }

    // Prevent both slots from showing the same model: disable that option
    // on the *other* slot's select, re-enabling whatever it previously
    // disabled if it's no longer the duplicate.
    function syncDisabledOptions() {
      slots.forEach(function (slot, i) {
        var otherValue = slots[i === 0 ? 1 : 0].select.value;
        Array.prototype.forEach.call(slot.select.options, function (option) {
          option.disabled = option.value === otherValue;
        });
      });
    }

    slots.forEach(function (slot) {
      slot.select.addEventListener('change', function () {
        showPanel(slot, slot.select.value);
        syncDisabledOptions();
      });
    });

    syncDisabledOptions();
  }

  function initAll(context) {
    (context || document).querySelectorAll('.comparison-table').forEach(initComparisonTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor: re-init when this section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();